
import { installPassport, isInHospEnv, isProd } from '../services/base';
import { defineComponent, onMounted, reactive } from 'vue';
import { LoginBox } from '@linkdoc/uc-loginbox';
import PrivateLogin from './PrivateLogin.vue';
import { isNuc } from '@/utils/env';

export default defineComponent({
  components: {
    LoginBox,
    PrivateLogin
  },
  setup() {
    interface LoginState {
      isInHospEnv: boolean;
    }
    const state = reactive<LoginState>({
      // 不建议在此给初始值，会呈现内容变动情况
      isInHospEnv: !!isInHospEnv
    });

    onMounted(() => {
      if (isInHospEnv) {
        console.log('私有化部署');
        // 私有化部署
      } else {
        // 云端部署 注册登录窗
        if (isProd()) {
          installPassport();
        }
      }
    });

    return {
      state,
      isNuc
    };
  }
});
